import { Link } from 'react-router-dom';
import { docsNavSections } from '../docs-nav-data';
import { DocsNavLink } from '../types';

interface DocsPagerProps {
  slug: string;
}

// Page order follows the sidebar, so the pager stays in sync when pages are added or moved.
const orderedLinks = docsNavSections.flatMap((section) => section.links);

function PagerLink({ link, label, isNext }: { link: DocsNavLink; label: string; isNext?: boolean }) {
  return (
    <Link
      to={`/docs/${link.slug}`}
      className={`group flex min-w-0 flex-col gap-1 ${isNext ? 'items-end text-right' : 'items-start text-left'}`}
    >
      <span className="text-xs uppercase tracking-widest text-muted-foreground">{label}</span>
      <span className="text-base text-foreground group-hover:text-link-accent">{link.label}</span>
    </Link>
  );
}

export function DocsPager({ slug }: DocsPagerProps) {
  const index = orderedLinks.findIndex((link) => link.slug === slug);
  if (index === -1) return null;

  const previous = orderedLinks[index - 1];
  const next = orderedLinks[index + 1];

  return (
    <nav aria-label="Docs pages" className="mt-12 flex items-start justify-between gap-6 border-t border-border pt-6">
      <div className="min-w-0 flex-1">{previous && <PagerLink link={previous} label="Previous" />}</div>
      <div className="flex min-w-0 flex-1 justify-end">{next && <PagerLink link={next} label="Next" isNext />}</div>
    </nav>
  );
}
